var map = {
	"./ar/index.json": 8010,
	"./bn/index.json": 2809,
	"./bs/index.json": 7202,
	"./da/index.json": 3850,
	"./de/index.json": 6214,
	"./en/index.json": 7402,
	"./es/index.json": 9598,
	"./fa/index.json": 7588,
	"./fr/index.json": 1081,
	"./ha/index.json": 3662,
	"./hi/index.json": 1526,
	"./id/index.json": 5276,
	"./it/index.json": 8764,
	"./nl/index.json": 1515,
	"./no/index.json": 4122,
	"./pt/index.json": 1357,
	"./ru/index.json": 124,
	"./se/index.json": 8337,
	"./so/index.json": 5063,
	"./sw/index.json": 6732,
	"./tg/index.json": 5588,
	"./th/index.json": 9717,
	"./tl/index.json": 6705,
	"./tr/index.json": 8907,
	"./ug/index.json": 7749,
	"./ur/index.json": 334,
	"./zh/index.json": 5955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4584;